import React from 'react';
import Modal from 'react-modal';
import './modal.css'

Modal.setAppElement('#root');

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    width: '90%',
    maxWidth: '460px',
    padding: '40px',
    borderRadius: '10px',
    boxShadow: '0 0 20px 0 rgba(0,0,0,.1)',
    border: 'none',
    boxSizing: 'border-box'
  },
  overlay: {
    backgroundColor: 'rgba(0,0,0,.3)',
    zIndex: '50'
  },
};

const ReactModal = ({ isOpen, onRequestClose, children }) => {
  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose} style={customStyles}>
      <button onClick={onRequestClose} className='close-modal' aria-label='Close'></button>
      {children}
    </Modal>
  );
};

export default ReactModal;


// WEBPACK FOOTER //
// ./src/components/Modal/index.js